export const PLACEHOLDER = "[CONTENT TO BE PROVIDED]";

export const ORG = {
  name: "Susanna Charitable Trust",
  registration: "E/21744/AHD",
  location: "Ahmedabad, Gujarat, India",
  founded: "18 March 2017",
  objective:
    "To help underprivileged children with their education and to support women's empowerment.",
  facebook: "https://www.facebook.com/SusannaSarvaria",
  email: "susanna@susannacharitable.com",
  phone: "+91 97129 88812",
  address: "C6, Siddhidarshan Apartment, Opp. Seema Hall, Satellite, Ahmedabad – 380015, Gujarat, India",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About Us", to: "/about" },
  { label: "Our Work", to: "/our-work" },
  { label: "Impact", to: "/impact" },
  { label: "Get Involved", to: "/get-involved" },
  { label: "Transparency", to: "/transparency" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  hero: {
    url: "/images/hero-home.jpg",
    alt: "Women receiving sarees and groceries at the Susanna Charitable Trust Christmas distribution, December 2025",
    real: true,
  },
  getInvolved: {
    url: "/images/event-lambha-2018.jpg",
    alt: "A young student in Lambha receiving a notebook from a trustee of Susanna Charitable Trust, May 2018",
    real: true,
  },
  volunteer: {
    url: "https://images.unsplash.com/photo-1758599668209-783bd3691ec8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHx2b2x1bnRlZXJzJTIwaGVscGluZyUyMGNvbW11bml0eXxlbnwwfHx8fDE3ODY3MjkzODV8MA&ixlib=rb-4.1.0&q=85",
    alt: "Temporary documentary-style placeholder photograph — volunteers",
  },
};

// Real, documented events from the Trust's own Facebook reports, newest first.
// Photos are self-hosted copies (Facebook CDN links expire).
const ev = (slug, title, location, date, sortKey, children, description, img, fbId, category) => ({
  slug,
  title,
  location,
  year: date,
  sortKey,
  children,
  description,
  image: { url: `/images/${img}.jpg`, alt: `${title} — Susanna Charitable Trust` },
  facebookUrl: `https://www.facebook.com/share/p/${fbId}/`,
  category,
  real: true,
});

export const EVENTS = [
  ev("methodist-nursing-school", "Notebook Distribution — Methodist Nursing School", "Nadiad", "10 July 2026", "2026-07-10", null,
    "A trustee of Susanna Charitable Trust visited Methodist Nursing School and distributed notebooks to the nursing students, in the gracious presence of the DS & Director.",
    "methodist-nursing-notebooks", "1BAr6F6AEV", "Education"),
  ev("godhra-villages", "Village Visits — Godhra District", "Vanta · Chalali · Rabod · Godhra", "26 June 2026", "2026-06-26", null,
    "The Trust visited the villages of Vanta, Chalali and Rabod in Godhra District, as well as Bowman Methodist Hostel, Godhra — described by the Trust as a truly blessed and memorable time.",
    "event-godhra-villages", "1EmVYNQHv6", "Education"),
  ev("grace-methodist-singarva", "Notebook Distribution — Grace Methodist Church", "Singarva", "10 June 2026", "2026-06-10", null,
    "Susanna Charitable Trust had the privilege of distributing notebooks to students at Grace Methodist Church, Singarva.",
    "event-grace-methodist-singarva", "1QD3sRJr1J", "Education"),
  ev("nadiad-villages", "Notebook Distribution — Four Villages of Nadiad District", "Vaso · Sapla · Khuntaj · Manjipura", "9 June 2026", "2026-06-09", 102,
    "Susanna Charitable Trust had the privilege of distributing notebooks to a total of 102 students in the villages of Vaso, Sapla, Khuntaj and Manjipura, Nadiad District.",
    "event-nadiad-villages", "1BbkbX8ruc", "Education"),
  ev("agape-methodist-ranipur", "Notebook Distribution — Agape Methodist Church", "Ranipur", "8 June 2026", "2026-06-08", 41,
    "Susanna Charitable Trust had the privilege of distributing notebooks to 41 children at Agape Methodist Church, Ranipur.",
    "event-agape-methodist-ranipur", "1Q4NWKDXjt", "Education"),
  ev("hope-methodist-baroda", "Notebook Distribution — Hope Methodist Church", "Baroda", "6 June 2026", "2026-06-06", 63,
    "Susanna Charitable Trust had the privilege of distributing notebooks to 63 children at Hope Methodist Church, Baroda.",
    "event-hope-methodist-baroda", "1EoSsDEK1m", "Education"),
  ev("sinai-methodist", "Notebook Distribution — Sinai Methodist Church", "Maheshwari Area", "5 June 2026", "2026-06-05", 65,
    "Susanna Charitable Trust had the privilege of distributing notebooks to about 65 children at Sinai Methodist Church, Maheshwari Area. The distribution was carried out by Trustees Triza and Jimmy.",
    "event-sinai-methodist", "1DZjmjbX8u", "Education"),
  ev("abel-methodist", "Notebook Distribution Programme Launched — Abel Methodist Church", "Vinobabhave Nagar", "2 June 2026", "2026-06-02", null,
    "Susanna Charitable Trust launched its notebook distribution programme at Abel Methodist Church, Vinobabhave Nagar, distributing notebooks among the students of the church.",
    "event-abel-methodist", "1cmJ82kRph", "Education"),

  ev("christmas-2025", "Groceries & Sarees — Christmas Distribution", "Sinal · Alfa · Grace Methodist Church areas", "17 December 2025", "2025-12-17", null,
    "Grocery kits and sarees were distributed around the Sinal, Alfa and Grace Methodist Church areas for Christmas.",
    "event-christmas-2025", "188VMj629B", "Community Development"),
  ev("dumral-2025", "Notebook Distribution — Dumral Village", "Dumral", "14 September 2025", "2025-09-14", null,
    "The trustees of Susanna Charitable Trust visited Dumral village to distribute notebooks to the students — a meaningful occasion for the whole team.",
    "event-dumral-2025", "1CcViiLJFq", "Education"),
  ev("sinal-2025", "Notebook Distribution — Sinal Methodist Church", "Sinal", "11 August 2025", "2025-08-11", null,
    "The Trust brought smiles to young faces at Sinal Methodist Church, continuing its commitment to children's education.",
    "event-sinal-2025", "1EgVDsW6n3", "Education"),
  ev("glimpse-july-2025", "A Glimpse of the Trust's Work", null, "16 July 2025", "2025-07-16", null,
    "A photo glimpse of the Trust's ongoing fieldwork — notebook distributions across communities, shared with a request for prayers and support.",
    "event-glimpse-july-2025", "1EhXrqzSZe", "Education"),
  ev("kathlal-school-2025", "Festival of Education — Methodist Mission Primary School", "Kathlal", "30 June 2025", "2025-06-30", null,
    "A trustee of the Trust graced the Festival of Education at Methodist Mission Primary School, Kathlal, as Chief Guest.",
    "event-kathlal-school-2025", "19Ajo9Um86", "Education"),
  ev("hathijan-2025", "Notebook Drive — Hathijan & Vinobabhave Nagar", "Hathijan · Vinobabhave Nagar", "8 June 2025", "2025-06-08", null,
    "The Trust launched a notebook distribution drive for students of Hathijan and Vinobabhave Nagar, with good wishes for their academic success.",
    "event-hathijan-2025", "1EfREpWiwz", "Education"),
  ev("agape-march-2025", "Groceries & Notebooks — Agape Methodist Church, Ranipur", "Ranipur", "7 March 2025", "2025-03-07", null,
    "Grocery kits and notebooks were distributed to needy families and students at Agape Methodist Church, Ranipur.",
    "event-agape-march-2025", "1JNgrFq4Pp", "Community Development"),

  ev("fulpura-2024", "Groceries, Clothes & Sarees — Fulpura Village", "Fulpura", "12 December 2024", "2024-12-12", null,
    "Grocery kits, clothes and sarees were distributed at Fulpura village.",
    "event-fulpura-2024", "1KvfyGcncT", "Community Development"),
  ev("tundav-savli-2024", "Notebook Distribution — Tundav & Savli", "Tundav · Savli", "30 June 2024", "2024-06-30", null,
    "Notebooks were distributed to students of Tundav and Savli villages.",
    "event-tundav-savli-2024", "14pD3BmjN6U", "Education"),
  ev("north-district-2024", "Notebook Distribution — North District, Seven Churches", "Jaitun Jubilee · Grace · Alfa · Sinai · Eden · Carmel · Tamil Church", "9 June 2024", "2024-06-09", 220,
    "Notebooks were distributed to 220 students of the Jaitun Jubilee, Grace, Alfa, Sinai, Eden, Carmel and Tamil churches of the North District, with the support of DS Rev. Esah Muthiah, Rev. Jashwant Macwan and Rev. Vijay.",
    "event-north-district-2024", "19RQwLXnsb", "Education"),

  ev("agape-2023", "Notebook Distribution — Agape Methodist Church, Ranipur", "Ranipur", "13 August 2023", "2023-08-13", null,
    "Notebooks were distributed to the students of Agape Methodist Church, Ranipur village.",
    "event-agape-2023", "1DXYgurN5s", "Education"),
  ev("umreth-2023", "Notebook Distribution — 13 Villages of Umreth District", "Khijalpur · Kalsar · Rakhiyal · Jakhed · Vanoti · Rasulpur · Ekalvelu · Pilol · Thamna · Pansora · Ghora · Heranj · Thasra", "9 July 2023", "2023-07-09", null,
    "Notebooks were distributed across thirteen villages of Umreth district.",
    "event-umreth-2023", "1BWcE3bRhz", "Education"),
  ev("barejadi-2023", "Notebooks & Stationery — Barejadi, Nandej & Lambha", "Barejadi · Nandej · Lambha", "19 June 2023", "2023-06-19", null,
    "Notebooks and stationery were distributed to students of Barejadi, Nandej and Lambha villages.",
    "event-barejadi-2023", "1CP2uQYKtq", "Education"),
  ev("roadside-jan-2023", "Roadside Relief", "Ahmedabad", "27 January 2023", "2023-01-27", null,
    "Roadside help was extended to people in need.",
    "event-roadside-jan-2023", "1MmdvoGDTn", "Community Development"),

  ev("sarees-christmas-2022", "Saree & Kit Distribution — Christmas", null, "19 December 2022", "2022-12-19", null,
    "Sarees were distributed to villagers, joining the Methodist Church Ahmedabad West kit distribution for Christmas.",
    "event-sarees-christmas-2022", "19PL9XxVYS", "Community Development"),
  ev("vatva-2022", "Notebook Distribution — Vatva Methodist Church", "Vatva", "3 July 2022", "2022-07-03", null,
    "Notebooks were distributed to students of Vatva Methodist Church.",
    "event-vatva-2022", "1DXGVo2GeC", "Education"),
  ev("kathlal-villages-2022", "Notebook Distribution — Six Villages of Kathlal District", "Bhumas · Mangalpur · Singhali · Nani Khadol · Moti Khadol · Balol", "1 July 2022", "2022-07-01", null,
    "Notebooks were distributed at Bhumas, Mangalpur, Singhali, Nani Khadol, Moti Khadol and Balol in Kathlal district.",
    "event-kathlal-villages-2022", "1cBJEGPzoq", "Education"),
  ev("odhav-2022", "Notebook Distribution — Rabari Vasahat, Odhav", "Odhav", "12 June 2022", "2022-06-12", null,
    "Notebooks were distributed to children in the Rabari Vasahat area of Odhav.",
    "event-odhav-2022", "187sePCzRt", "Education"),
  ev("roadside-feb-2022", "Roadside Relief", "Ahmedabad", "15 February 2022", "2022-02-15", null,
    "Roadside help was extended to people in need.",
    "event-roadside-feb-2022", "18WwfypcjS", "Community Development"),

  ev("baroda-2021", "Notebook Distribution — Baroda District Churches", "Baroda District", "24 July 2021", "2021-07-24", 100,
    "Notebooks were distributed across various area churches in Baroda district, reaching more than 100 students.",
    "event-baroda-2021", "19E4usKPYe", "Education"),
  ev("grace-hudco-2021", "Notebook Distribution — Grace Methodist Church, Hudco", "Hudco, Kathwada", "4 July 2021", "2021-07-04", null,
    "Notebooks were distributed at Grace Methodist Church, Hudco, Kathwada, accompanied by Rev. Yohan Khristi and Rev. George Christian.",
    "event-grace-hudco-2021", "18hFgZxAT3", "Education"),
  ev("olive-gayatrinagar-2021", "Notebook Distribution — Olive Methodist Church", "Gayatrinagar", "27 June 2021", "2021-06-27", null,
    "Notebooks were distributed to students at Olive Methodist Church in the Gayatrinagar area.",
    "event-olive-gayatrinagar-2021", "1DRBM9e67L", "Education"),
  ev("nadiad-all-2021", "Notebook Distribution — Villages of Nadiad District", "Nadiad District", "21 June 2021", "2021-06-21", null,
    "Notebooks were distributed across the villages of Nadiad district, with arrangements by Rev. Emmanuel Kant and local pastors.",
    "event-nadiad-all-2021", "1EKLZ9NqtE", "Education"),
  ev("oxygen-2021", "Oxygen Cylinder for the Trust's Ambulance", null, "6 June 2021", "2021-06-06", null,
    "Mrs. Sangeetaben and Mr. Lincoln Christian and family provided an oxygen cylinder with all equipment for the Trust's ambulance.",
    "event-oxygen-2021", "19AsaNRpWF", "Healthcare & Wellbeing"),
  ev("ambulance-2021", "Dedication of an Ambulance", null, "23 May 2021", "2021-05-23", null,
    "The dedication ceremony of an ambulance for the Trust's work.",
    "event-ambulance-2021", "1Ba2emdEgp", "Healthcare & Wellbeing"),

  ev("panchmahal-rajasthan-2020", "Groceries Kit Distribution — Panchmahal & Rajasthan", "Panchmahal · Rajasthan", "17 November 2020", "2020-11-17", null,
    "Grocery kits were distributed in Panchmahal and Rajasthan.",
    "event-panchmahal-rajasthan-2020", "1GweoAJJYr", "Community Development"),
  ev("kathlal-groceries-2020", "Groceries Kit Distribution — 12 Villages of Kathlal", "Kathlal District (12 villages)", "24 October 2020", "2020-10-24", null,
    "Grocery kits were distributed across 12 villages in Kathlal district.",
    "event-kathlal-groceries-2020", "1EdvzaNZ4L", "Community Development"),
  ev("notebooks-oct-2020", "Notebook Distribution", null, "17 October 2020", "2020-10-17", null,
    "A notebook distribution for students, documented in October 2020.",
    "event-notebooks-oct-2020", "1LToquJrQ9", "Education"),
  ev("study-help-2020", "Study Support for Children", null, "19 July 2020", "2020-07-19", null,
    "The Trust extended help to children in their studies.",
    "event-study-help-2020", "18foQCe7sH", "Education"),

  ev("june-2019", "Notebook Distribution — June 2019 Drive", null, "30 June 2019", "2019-06-30", null,
    "Children received notebooks at this June 2019 distribution event, documented by the Trust as a blessed occasion.",
    "event-june-2019", "1VJvffrkPg", "Education"),
  ev("lambha-2019", "Support for Students — Lambha Village", "Lambha", "22 June 2019", "2019-06-22", null,
    "Help was extended to Lambha village students, organised with the support of Rev. Jashwant Macwan.",
    "event-lambha-2019", "1E6haYkkbC", "Education"),
  ev("five-churches-2019", "Notebook Support — Five Churches", "Hosanna · Calvery · Hope · Dabhoi · Bethany Asarwa", "3 June 2019", "2019-06-03", null,
    "Support was given to students of the Hosanna, Calvery, Hope, Dabhoi and Bethany Asarwa churches.",
    "event-five-churches-2019", "1D1Fd86cZj", "Education"),
  ev("ranipur-children-2019", "Support for Children — Ranipur Village", "Ranipur", "26 May 2019", "2019-05-26", null,
    "Help was extended to the children of Ranipur village.",
    "event-ranipur-children-2019", "1FC5BzFTbj", "Education"),

  ev("amreli-2018", "Mission Field Visit — Amreli", "Amreli", "8 December 2018", "2018-12-08", null,
    "Trustees of the Trust, together with pastorate committee members of Methodist Church Ahmedabad West and pastor Rev. Ashok Parmar, visited the Amreli mission field.",
    "event-amreli-2018", "1EFdkgrv3s", "Community Development"),
  ev("blankets-elderly-2018", "Blankets & Lunch for the Elderly", null, "24 November 2018", "2018-11-24", null,
    "Blankets and lunch were provided to elderly people, with special thanks to Director Rev. Vijay Parmar and Rev. Ashok Parmar.",
    "event-blankets-elderly-2018", "1EwU6whQHj", "Community Development"),
  ev("flood-relief-2018", "Flood Relief Support", "Bharuch – Surat District", "30 July 2018", "2018-07-30", null,
    "The Trust extended help to flood-affected people in the Bharuch–Surat district region.",
    "event-flood-2018", "1HasqumEJ5", "Community Development"),
  ev("badapura-2018", "Notebook Distribution — Badapura Camp", "Badapura", "23 June 2018", "2018-06-23", null,
    "Notebooks were distributed to students at the Badapura camp.",
    "event-badapura-2018", "1EZ7mCBpos", "Education"),
  ev("anand-district-2018", "Notebook Distribution — Villages of Anand District", "Adas-Vasad · Alarsa-Sharon · Vaghasi-Mogar · Kunjrav · Tranol-Bedva · Karsanpura · Ajarpura", "2 June 2018", "2018-06-02", null,
    "Notebooks were distributed to students across Adas-Vasad, Alarsa-Sharon, Vaghasi-Mogar, Kunjrav, Tranol-Bedva, Karsanpura and Ajarpura, with the support of D.S. Rev. Essahmuthaiyah, Rev. Benjamin and Rev. Kirit.",
    "event-anand-2018", "1HWvNS2hUD", "Education"),
  ev("abel-methodist-2018", "Notebook Distribution — Abel Methodist Church", "Vinobabhave Nagar", "26 May 2018", "2018-05-26", null,
    "Photographs from the Trust's early notebook distribution at Abel Methodist Church, Vinobabhave Nagar.",
    "event-abel-2018", "14mcvCi9Hgp", "Education"),
  ev("lambha-2018", "Notebook Distribution — Lambha", "Lambha", "19 May 2018", "2018-05-19", null,
    "Notebooks were distributed to students in Lambha.",
    "event-lambha-2018", "1Hx22mLj47", "Education"),
  ev("widows-2018", "Support for Widows", null, "1 March 2018", "2018-03-01", null,
    "Susanna Charitable Trust extended help to widows, as part of its commitment to women's empowerment.",
    "event-widows-2018", "1PMQvrjgMt", "Support & Empowerment"),

  ev("khijalpur-2017", "Food Kits & Clothes Distribution — Khijalpur Village", "Khijalpur", "29 December 2017", "2017-12-29", null,
    "Food kits and clothes were distributed at Khijalpur village, with Trustee Jimmy Christie and team.",
    "event-khijalpur-2017", "18iHfjV2CV", "Community Development"),
  ev("food-kits-2017", "Food Kits & Clothes Distribution", "Across Gujarat", "22 December 2017", "2017-12-22", null,
    "Susanna Charitable Trust distributed food kits and clothes to families in need across Gujarat — one of the Trust's earliest documented outreach efforts.",
    "event-food-kits-2017", "1JW2weXaw6", "Community Development"),
];

const bySlug = (s) => EVENTS.find((e) => e.slug === s);

export const WORK_AREAS = [
  {
    number: "01",
    slug: "education",
    title: "Education",
    description:
      "Since 2018, the Trust's notebook and stationery drives have reached 591+ students — from single churches in Lambha and Singarva to 220 students across seven North District churches and whole village clusters in Nadiad, Anand, Umreth and Kathlal.",
    image: bySlug("north-district-2024").image,
    real: true,
  },
  {
    number: "02",
    slug: "community-development",
    title: "Community Development",
    description:
      "Food kits, groceries, clothes and sarees for families in need — from Khijalpur village in 2017 to twelve villages of Kathlal in a single 2020 drive, flood relief in Bharuch–Surat, and Christmas distributions that continue every year.",
    image: bySlug("khijalpur-2017").image,
    real: true,
  },
  {
    number: "03",
    slug: "healthcare-wellbeing",
    title: "Healthcare & Wellbeing",
    description:
      "In 2021 the Trust dedicated an ambulance, equipped with oxygen support gifted by a well-wishing family — its first documented step into healthcare.",
    image: bySlug("ambulance-2021").image,
    real: true,
  },
  {
    number: "04",
    slug: "support-empowerment",
    title: "Support & Empowerment",
    description:
      "Help for widows, blankets and lunch for the elderly, and roadside relief in Ahmedabad — the quiet, personal side of the Trust's work, documented since 2018.",
    image: bySlug("widows-2018").image,
    real: true,
  },
];

// Figures below are compiled only from the Trust's own documented event reports.
export const IMPACT_STATS = [
  { label: "Students Reached", value: "591+", note: "From documented distributions" },
  { label: "Documented Events", value: "51", note: "2017 – present, on Facebook" },
  { label: "Locations Served", value: "60+", note: "Counted conservatively from reports" },
  { label: "Years of Service", value: "9", note: "Founded 18 March 2017" },
];

export const STATS_DISCLAIMER =
  "Figures are compiled from the Trust's own documented event reports and cover only stated counts — many events did not publish numbers. Official audited figures will replace these once supplied by the Trust.";

export const IMPACT_STORIES = [bySlug("methodist-nursing-school"), bySlug("north-district-2024"), bySlug("flood-relief-2018")];

export const FEATURED_STORY = {
  heading: "One Story. One Community. One Difference.",
  projectName: bySlug("methodist-nursing-school").title,
  location: bySlug("methodist-nursing-school").location,
  date: bySlug("methodist-nursing-school").year,
  story: bySlug("methodist-nursing-school").description,
  impact: null,
  image: bySlug("methodist-nursing-school").image,
  facebookUrl: bySlug("methodist-nursing-school").facebookUrl,
  real: true,
};

export const PROJECTS = EVENTS.map((e) => ({
  title: e.title,
  category: e.category,
  slug: e.slug,
  location: e.location,
  date: e.year,
  sortKey: e.sortKey,
  description: e.description,
  impact: null,
  image: e.image,
  real: true,
}));

export const LEADERSHIP = [
  {
    name: "Triza Jimmy Christie",
    role: "Settlor & Trustee",
    bio: "Triza leads the Trust's education outreach — personally carrying out notebook distributions and representing the Trust at occasions such as the Festival of Education at Methodist Mission Primary School, Kathlal.",
    image: "/images/trustee-triza.jpg",
    real: true,
  },
  {
    name: "Jimmy Franklin Christie",
    role: "Trustee",
    bio: "Jimmy has led the Trust's distribution drives across Gujarat since its earliest years — from food kits and clothes at Khijalpur in 2017 to notebook programmes reaching hundreds of students today.",
    image: "/images/trustee-jimmy.jpg",
    real: true,
  },
  {
    name: "Denzil Joyprakash Christian",
    role: "Trustee",
    bio: "Denzil serves as a trustee of Susanna Charitable Trust, supporting the Trust's governance and programme work.",
    image: "/images/trustee-denzil.jpg",
    real: true,
  },
];

export const INVOLVE_WAYS = [
  {
    number: "01",
    title: "Donate",
    description: "Help fund the Trust's work. Every contribution supports programmes in the communities we serve.",
    cta: "Donate Now",
    to: "/donate",
  },
  {
    number: "02",
    title: "Volunteer",
    description: "Offer your time and skills. Tell us how you would like to contribute and we will be in touch.",
    cta: "Become a Volunteer",
    to: "/contact?subject=Volunteering",
  },
  {
    number: "03",
    title: "Partner With Us",
    description: "For organisations, companies and institutions interested in working with the Trust.",
    cta: "Start a Conversation",
    to: "/contact?subject=Partnership",
  },
  {
    number: "04",
    title: "Spread the Word",
    description: "Help amplify the Trust's work by sharing it with your community and network.",
    cta: "Visit Our Facebook Page",
    to: ORG.facebook,
    external: true,
  },
];

export const DOCUMENT_SECTIONS = [
  {
    title: "Trust Registration",
    note: "Reg. No. E/21744/AHD · Issued 18 March 2017 · Deputy Charity Commissioner, Ahmedabad · Bombay Public Trusts Act, 1950",
    file: "/documents/trust-registration-certificate.pdf",
  },
  {
    title: "Trust Deed",
    note: "Executed 24 January 2017",
    file: "/documents/trust-deed.pdf",
  },
  {
    title: "12A / 12AB Certificate",
    note: "PAN AASTS8120R · Reg. AASTS8120R/291/17-18/T-2333/12AA · Issued 30 Nov 2017 · CIT (Exemptions), Ahmedabad",
    file: "/documents/12aa-certificate.pdf",
  },
  {
    title: "80G Certificate",
    note: "Approval SCT/2017-18/182/80G(5)/T-1312 · Issued 30 Nov 2017 · Renewal in progress",
    file: "/documents/80g-certificate.pdf",
  },
  { title: "CSR Registration", note: null, file: null },
  { title: "Annual Reports", note: null, file: null },
  { title: "Audited Financial Statements", note: null, file: null },
  { title: "Other Statutory Documents", note: null, file: null },
];

export const VALUES = [
  {
    name: "Education First",
    description:
      "Every child deserves the tools to learn. The Trust's deed commits it to notebooks, stationery, scholarships and support for educational institutions.",
  },
  {
    name: "Women's Empowerment",
    description:
      "The deed commits the Trust to women's education, employment, entrepreneurship and social uplift — a founding purpose, not an afterthought.",
  },
  {
    name: "Care for the Vulnerable",
    description:
      "Food, clothing, medical help and humanitarian support for the poor, the elderly, the disabled and orphaned children.",
  },
  {
    name: "Compassion in Action",
    description:
      "The Trust's own motto — help that shows up in person, in villages, churches, schools and homes across Gujarat.",
  },
];

export const DONATION_AMOUNTS = [500, 1000, 2500, 5000, 10000];

export const MARQUEE_ITEMS = [
  "Susanna Charitable Trust",
  "Reg. No. E/21744/AHD",
  "Founded 18 March 2017",
  "51 Documented Events",
  "591+ Students Reached",
  "Ahmedabad · Gujarat · India",
];
